export default "__VITE_ASSET__pt1waFP1__";